import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import {
  PolicyFixInput,
  PolicyFixInputOption,
} from '../../../types/issues-types';

const OPTIONS_TO_SHOW = 10;

const getOptionsText = (options: PolicyFixInputOption[]) => {
  const selected = options.filter(o => o.selected);
  return (
    selected
      .map(o => o.displayName)
      .slice(0, OPTIONS_TO_SHOW)
      .join(', ') +
    `${
      selected.length > OPTIONS_TO_SHOW
        ? ` +${selected.length - OPTIONS_TO_SHOW}`
        : ''
    }`
  );
};

const PolicyFixConfirmation: FC<
  React.PropsWithChildren<PolicyFixConfirmationProps>
> = props => {
  const { variables, confirmation } = props;
  return (
    <>
      <Typography variant='body2' color='text.primary'>
        The following options were selected: <br />
        <br />
      </Typography>
      {variables.map(input => {
        return (
          <Box
            component='span'
            key={input.name}
            display='flex'
            flexDirection='row'
            alignItems='flex-start'
            gap={1}>
            <Typography
              variant='body2'
              color='text.primary'
              sx={{ textTransform: 'capitalize' }}>
              {input.displayName}:
            </Typography>

            <Typography variant='body2' color='text.secondary'>
              {getOptionsText(input.options)}
            </Typography>
          </Box>
        );
      })}
      {confirmation && (
        <Typography variant='body2' color='text.primary'>
          <br /> <br />
          {confirmation}
        </Typography>
      )}
    </>
  );
};

export interface PolicyFixConfirmationProps {
  variables: PolicyFixInput[];
  confirmation?: string;
}

export default PolicyFixConfirmation;
